module.exports = __webpack_public_path__ + "img/vector-graphics.af9c49c.png";